/**
 * Checks if a node/element exists
 * @param {HTMLElement|Element} node - The node/element to check
 * @returns {Boolean}
 */
function isSet(node){
    if (typeof(node) != 'undefined' && node != null && node != "") {
        return true;
    }else{
        return false;
    }
}

export { isSet };